import { useIntl } from '@grandvisionhq/state';
import { useRxGlassesConfiguratorContext } from '../../../../context/RxGlassesConfiguratorContext.js';
import { PD_LINK_DRAWER_TRIGGER_LABEL } from '../types.js';

const usePupillaryDistanceDrawerLink = ()=>{
    var ref;
    const { hasLabel  } = useIntl();
    const { configuratorDocument  } = useRxGlassesConfiguratorContext();
    const hasMeasurementInformation = configuratorDocument === null || configuratorDocument === void 0 ? void 0 : (ref = configuratorDocument.prescriptionStep) === null || ref === void 0 ? void 0 : ref.measureDescription;
    return Boolean(hasLabel(PD_LINK_DRAWER_TRIGGER_LABEL) && hasMeasurementInformation);
};

export { usePupillaryDistanceDrawerLink };
//# sourceMappingURL=use-pupillary-distance-drawer-link.js.map
